import { render, staticRenderFns } from "./FavoritesListing.vue?vue&type=template&id=16c993a0"
import script from "./FavoritesListing.vue?vue&type=script&lang=js"
export * from "./FavoritesListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports